import { StyledButton, StyledButtonAnchor } from './Button.Styled'

const Button = ({
  text,
  onClick,
  href,
  className,
  margin,
  width,
  color,
  backgroundColor,
  variant,
  type = 'button',
  minimized = true,
  newTab = false,
}) => {
  if (href) {
    return (
      <StyledButtonAnchor
        minimized={minimized}
        href={href}
        className={className}
        margin={margin}
        width={width}
        color={color}
        variant={variant}
        backgroundColor={backgroundColor}
        target={newTab ? '_blank' : '_self'}
      >
        {text}
      </StyledButtonAnchor>
    )
  }
  return (
    <StyledButton
      minimized={minimized}
      onClick={onClick}
      className={className}
      margin={margin}
      type={type}
      width={width}
      color={color}
      variant={variant}
      backgroundColor={backgroundColor}
    >
      {text}
    </StyledButton>
  )
}

export default Button
